import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Layout from '@/layout'

const prefix = 'temp'

const router = new VueRouter({
  mode: "history", //路由模式
  base: "/web/new_website", //部署的子路径

  routes: [{
      path: '/',
      component: Layout,
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: `${prefix}-index`,
          component: () => import('@/views/index')
        },
        {
          path: '/user-center',
          name: `${prefix}-user-center`,
          component: () => import('@/views/user-center')
        },
        {
          path: '/detail',
          name: `${prefix}-detail`,
          component: () => import('@/views/detail')
        },
        {
          path: '/game-list',
          name: 'game-list',
          component: () => import('@/views/game-list')
        },
        {
          path: '/image-list',
          name: 'image-list',
          component: () => import('@/views/image-list')
        },
        {
          path: '/image-detail',
          name: `${prefix}-image-detail`,
          component: () => import('@/views/image-detail')
        },
        {
          path: '/video-list',
          name: 'video-list',
          component: () => import('@/views/video-list')
        },
        {
          path: '/video-detail',
          name: `${prefix}-video-detail`,
          component: () => import('@/views/video-detail')
        },
        {
          path: '/certificate-download',
          name: 'certificate-download',
          component: () => import('@/views/certificate-download')
        },
        {
          path: '/registration',
          name: 'registration',
          component: () => import('@/views/registration')
        },
        {
          path: '/registration-detail',
          name: 'registration-detail',
          component: () => import('@/views/registration-detail')
        },
        {
          path: '/league-game-list',
          name: 'league-game-list',
          component: () => import('@/views/league-game-list')
        },
        {
          path: '/score-ranking',
          name: 'score-ranking',
          component: () => import('@/views/score-ranking')
        },
      ]
    },
  ],
  scrollBehavior() {
    // 始终滚动到顶部
    return { x: 0, y: 0 }
  }
})


export default router

//防止报路由重复
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js